import { createContext } from 'react';

import {
  MaintenanceWindow,
  MaintenanceWindowFilters,
} from '@totem/components/maintenanceWindowsV2/types';

export const DEFAULT_FILTERS: MaintenanceWindowFilters = {
  regionIds: [],
  buildingIds: [],
  controlSystemIds: [],
  lookbackDays: 90,
};

interface Context {
  loading: boolean;
  failed: boolean;
  // Every window the user can see in the current organization.
  data: MaintenanceWindow[];
  // data narrowed by the region / building / control system filters.
  filteredData: MaintenanceWindow[];
  filters: MaintenanceWindowFilters;
  setFilters: (update: Partial<MaintenanceWindowFilters>) => void;
  // Time the data was loaded; status and "starts in" values are computed against it.
  now: number;
  sending: boolean;
  onAction: (action: string, item: MaintenanceWindow) => void;
}

export default createContext<Context>({
  loading: false,
  failed: false,
  data: [],
  filteredData: [],
  filters: DEFAULT_FILTERS,
  setFilters: () => {},
  now: Date.now(),
  sending: false,
  onAction: () => {},
});
